import React from "react";
import Input from "./UI/input";
import Button from "./UI/button";
import Icon from "./UI/icon";
import { category } from "../constants/category";
import Header from "./UI/header";
import { Link } from "react-router-dom";
import { numberMethod } from "../util/validator";

const inputClass =
  "w-full px-4 py-3 bg-gray-50 rounded-xl border border-purple-200 outline-none text-sm text-gray-900 placeholder-gray-400 focus:border-primary";

function AddUserForm(props) {
  const { handleSubmit, onChange, formData, id, isReturning } = props;

  const isValid = formData.userName && formData.count;

  return (
    <div className="max-w-md mx-auto">
      <div className="px-6 pt-6 pb-2">
        <Header className="text-2xl font-bold text-gray-900">
          {id ? "Update Customer" : "Add Customer"}
        </Header>
        <p className="text-sm text-gray-500 mt-1">
          {id
            ? "Edit the customer details below"
            : "Fill in the details to add a new customer"}
        </p>
      </div>
      <form
        onSubmit={handleSubmit}
        className="flex flex-col gap-y-3 px-6 py-4"
      >
        <div>
          <div className="flex items-center justify-between mb-1">
            <label className="text-xs font-medium text-gray-500">Name</label>
            {isReturning && (
              <span className="text-xs font-semibold text-green-600 bg-green-50 px-2 py-0.5 rounded-full">
                ↩ Returning
              </span>
            )}
          </div>
          <Input
            className={inputClass}
            type="text"
            name="userName"
            placeholder="Enter customer name"
            value={formData.userName}
            onChange={onChange}
          />
        </div>
        <div>
          <label className="text-xs font-medium text-gray-500 mb-1 block">
            Mobile Number <span className="text-gray-400">(Optional)</span>
          </label>
          <Input
            className={inputClass}
            type="text"
            name="mobileNumber"
            placeholder="Enter mobile number"
            value={formData.mobileNumber}
            onChange={onChange}
            onKey={numberMethod}
          />
        </div>
        <div>
          <label className="text-xs font-medium text-gray-500 mb-1 block">
            Guest Count
          </label>
          <Input
            className={inputClass}
            type="text"
            name="count"
            placeholder="Number of guests"
            value={formData.count}
            onChange={onChange}
          />
        </div>
        <div>
          <label className="text-xs font-medium text-gray-500 mb-2 block">
            Category
          </label>
          <div className="flex items-center gap-2">
            {category.map((cate) => {
              const selected = formData.category === cate.value;
              return (
                <button
                  key={cate.value}
                  type="button"
                  onClick={() =>
                    onChange({ target: { name: "category", value: cate.value } })
                  }
                  className={`flex-1 flex flex-col items-center gap-1.5 py-3 rounded-xl cursor-pointer ${
                    selected
                      ? "bg-primary-bg border border-primary"
                      : "bg-gray-50 border border-transparent"
                  }`}
                >
                  <Icon
                    icon={cate.icon}
                    className={selected ? "text-primary" : "text-gray-400"}
                  />
                  <span
                    className={`text-xs ${
                      selected
                        ? "text-primary font-medium"
                        : "text-gray-500"
                    }`}
                  >
                    {cate.name}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
        <div>
          <label className="text-xs font-medium text-gray-500 mb-1 block">
            Estimated Wait (min)
          </label>
          <Input
            className={inputClass}
            type="text"
            name="estimate"
            placeholder="e.g. 15"
            value={formData.estimate}
            onChange={onChange}
          />
        </div>
        <div>
          <label className="text-xs font-medium text-gray-500 mb-1 block">
            Notes <span className="text-gray-400">(Optional)</span>
          </label>
          <Input
            className={inputClass}
            type="text"
            name="notes"
            placeholder="Any special notes"
            value={formData.notes}
            onChange={onChange}
          />
        </div>
        <div className="flex gap-3 mt-4">
          <Button
            className={`flex-1 py-3 rounded-xl font-semibold text-sm ${
              isValid
                ? "bg-primary hover:bg-primary-light text-white"
                : "bg-gray-200 text-gray-400 cursor-not-allowed"
            }`}
            type="submit"
            disabled={!isValid}
          >
            {id ? "Update" : "Add Customer"}
          </Button>
          <Link to="/dashboard" className="flex-1">
            <Button
              className="w-full py-3 rounded-xl border border-gray-200 bg-white text-gray-700 text-sm font-semibold hover:bg-gray-50"
              type="reset"
            >
              Cancel
            </Button>
          </Link>
        </div>
      </form>
    </div>
  );
}

export default AddUserForm;
